import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HumanizePipe } from './humanize.pipe';
import { TextNormalizePipe } from './text-normalize.pipe';
import { ElementIdPipe } from './element-id.pipe';
import { MegabytePipe } from './megabyte.pipe';
import { PrettyPrintPipe } from './pretty-print.pipe';
import { EllipsisPipe } from './ellipsis.pipe';

@NgModule({
  declarations: [
    HumanizePipe,
    TextNormalizePipe,
    ElementIdPipe,
    MegabytePipe,
    PrettyPrintPipe,
    EllipsisPipe,
  ],
  exports: [
    HumanizePipe,
    TextNormalizePipe,
    ElementIdPipe,
    MegabytePipe,
    PrettyPrintPipe,
    EllipsisPipe,
  ],
  imports: [CommonModule],
})
export class PipesModule {}
